import 'normalize.css';
import '@unocss/reset/tailwind.css';
import 'virtual:uno.css';
import 'animate.css';

import './assets/main.scss'

import { createApp } from 'vue';
import { createPinia } from 'pinia'
import plugins from './plugins';

import App from './App.vue';
import router from './router';

import 'lazysizes';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(plugins);

app.mount('#app');
